<template>
  <button
    :class="{ disabled: !isProceedEnable || isLoading, loading: isLoading }"
    class="proceed-btn"
  >
    {{ isLoading ? '' : 'Proceed' }}
  </button>
</template>

<script>
export default {
  name: 'ProceedButton',
  props: {
    isProceedEnable: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
